import { IBaseline } from '@wizeoo/akm-compute-lib';

// mode d'appel du compute
export enum COMPUTE_CALL_MODE {
  COMPUTE = 'COMPUTE', // demande de calcul
  UPDATE = 'UPDATE', // mise à jour du calcul, création si nécessaire
  DELETE_STEP = 'DELETE_STEP', // suppression d'un / plusieurs step
  DELETE_VISION = 'DELETE_VISION', // suppression de toute la vision
  COUNT = 'COUNT', // compte le nombre de résultats pour un widget
  GET = 'GET', // collecte d'un résultat pour un widget
  LOAD_STEP = 'LOAD_STEP', // chargement d'un step en mémoire (test)
  CHRON = 'CHRON' // configurer le cron pour lancement auto
}

// Statut d'un calcul
export enum COMPUTE_STATUS {
  INITIATED = 'initiated',
  IN_PROGRESS = 'in_progress',
  ENDED = 'ended',
  ERROR = 'error'
}

/**
 * Résultats d'un calcul pour retour IHM
 * Les résultats sont organisés en Map (level=>scenario=>key)
 */
export interface ComputeEngineResult {
  // statut
  state: COMPUTE_STATUS;
  // erreurs éventuelles
  error: any;
 // l'indice de page
  page?: number; 
  // le nombre total de lignes dispos
  totalLines?: number;
  // Le pack de résultats
  lines?: IBaseline[];
  // ts
  time?: number;
  // numRev pour synchro IHM
  numRev?: number;
}

/**
 * Paramétres d'une requête HTTP de calcul
 */
export interface ComputeRequest {
  
  // le mode d'appel
  method: COMPUTE_CALL_MODE;

  // Code du domaine
  domain: string;

  // Code de la BU
  bu: string;

  // Code de la vision
  vision: string;

  // code éventuel du process
  pid?: string;

  // éléments de scenario pour jouer le compute
  // par exemple mode simu, définition de la locale...
  scenario: ComputeScenario;

  // critères pour jouer le compute
  // par exemple step cible, révisions...
  criteria: ComputeCriteria;
}

/**
 * critères d'une requête de calcul
 * Infos sur la validation et la transformation des données en entrée avec NestJS : https://docs.nestjs.com/techniques/validation
 */
export interface ComputeCriteria {
  
  // Code du scenario à calculer (ou vide si on veut tous les scénarios)
  scenario: string;

  // Niveau du step à calculer (ou vide si on veut tous les steps)
  level: number;

  // offset
  offset?: number;

  // taille de la page
  pageSize?: number;

  // Configuration du widget appelant (filtres, tri)
  // widgetConfiguration?: WidgetConfigurationObj;

  // les filtres (global, parent, widget)
  filter?: ComputeFilter[];

  // les éléments de tri
  sort?: ComputeSort[];

}

/**
 * une clé de tri
 */
export interface ComputeSort {
  kind: string; // Key, Filter ou mesure
  code: string; // code du champ
  ff: string; // champ sur les key/filters
  ord: number; // ordre dans la pile de tri
  way: string; // ASC /DESC
  num: boolean; // donnée numérique
  position?: number; // en cas de tri sur KEY, position du FD dans la clé
}

/**
 * un filtre
 */
export interface ComputeFilter {
  kind: string; // Key, Filter ou mesure (ou Master)
  code: string; // code du champ
  invalues?: string[]; // données du in séparées par |
  regmode?: boolean; // true si mode regex
  regex?: string; // expression régulière pour les filtres sur mesures
  field?: string; // en cas de regex, champ concerné (pour les keys)
  position?: number; // en cas de filtre sur KEY, position du FD dans la clé (ou taille du master)
}


/**
 * Paramétres supplémentaires d'une requête de calcul
 * n'impacte PAS le calcul, juste le rendu / les actions
 * Pour la gestion des traces et de la réponse des résultats
 *
 * Infos sur la validation et la transformation des données en entrée avec NestJS : https://docs.nestjs.com/techniques/validation
 */
export interface ComputeScenario {

  // Locale de l'utilisateur
  userLocale?: string;

  // Locale de la BU
  buLocale?: string;

  // Indique si on veut renvoyer le résulat du calcul dans la réponse
  // Potentiellement pas raisonnable si trop lourd
  output?: boolean;

  // Indique si on veut lancer la mise à jour sans sauvegarde des calculs
  simulate?: boolean;

  // Indique si on lance le calcul de façon asynchrone
  async?: boolean;

  // Indique si on veut activer les traces
  trace?: boolean;

  // Indique si on veut les métriques
  metric?: boolean;

  // Indique si on force le calcul
  force?: boolean;

  // on ne veut PAS calculer
  noCompute?: boolean;

  // modification du chron du compute depuis un appel COMPUTE_CALL_MODE.CHRON
  chron?: string;
}